<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Log Detail</strong>
            <span class="float-right">Date : {{model.created_at | datetime}}</span>
          </div>
          <!-- <pre>{{model}}</pre> -->
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b><label for="ph_username" v-b-tooltip.hover>username</label><br></b>
                <label for="ph_username" v-b-tooltip.hover>{{model.username}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_app_id" v-b-tooltip.hover>App</label><br></b>
                <label for="ph_app_id" v-b-tooltip.hover>
                  <b-badge  variant="primary"> {{model.app_id}} </b-badge>
                </label>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_addr_all" v-b-tooltip.hover>Action</label><br></b>
                <label for="ph_addr_all" v-b-tooltip.hover>{{model.action}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_addr" v-b-tooltip.hover>Address</label><br></b>
                <label for="ph_addr" v-b-tooltip.hover>{{model.addr}}</label>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_addr_all" v-b-tooltip.hover>Address all</label><br></b>
                <label for="ph_addr_all" v-b-tooltip.hover>{{model.addr_all}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button size="sm" class="float-right" variant="primary" @click="list">List</b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Api } from '@/service';

export default {
  data : () => {
    return {
      model : {},
    }
  },
  methods: {
    list() { this.$router.push({ name: 'log_system'}); },
    async get( id = this.$route.params) {
      console.log('log.system.detail.vue', 'load item', id);
      try {
        let rs = await Api.Manager_Call('log.system', 'detail', { id : Number(id.id) })
        this.model = rs.body;
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('log.system.detail.vue', 'created'); },
  destroyed() { console.log('log.system.detail.vue', 'destroyed'); },
  mounted() {
    console.log('log.system.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
